var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiLaptopFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bi:laptop-fill",
    clipPath: "url(#clip0_108_227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.78866 18.112C8.50595 18.4557 7.41232 19.2949 6.74834 20.4449C6.08436 21.5949 5.90443 22.9616 6.24813 24.2444L13.5917 51.6509L58.7319 39.5556L51.3883 12.1491C51.0446 10.8664 50.2055 9.77273 49.0554 9.10875C47.9054 8.44477 46.5387 8.26484 45.256 8.60854L9.78866 18.112ZM10.7994 54.127L62.3882 40.3038C62.7319 41.5865 62.552 42.9532 61.888 44.1033C61.224 45.2533 60.1304 46.0925 58.8477 46.4362L16.9317 57.6675C15.649 58.0112 14.2823 57.8313 13.1323 57.1673C11.9822 56.5034 11.1431 55.4097 10.7994 54.127Z",
    fill: "#E68532"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.4087,
    height: 53.4087,
    fill: "white",
    transform: "translate(0 13.8232) rotate(-15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiLaptopFill);
export default __webpack_public_path__ + "static/media/bi_laptop-fill.47c251c6d6a6fe4d377695b5b80ee246.svg";
export { ForwardRef as ReactComponent };